import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const VisitAverageAttendanceRedux = createActions({
  VisitAverageAttendanceExcelRequest: [''],
  VisitAverageAttendanceExcelSuccess: [''],
  VisitAverageAttendanceExcelError: ['error'],
},
{
  prefix: 'VISIT_AVERAGE_ATTENDANCE_',
  defaultActions: {
    get: true,
  },
},
)

const { Types, Creators } = VisitAverageAttendanceRedux
export const VisitAverageAttendanceTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

const VisitAverageAttendanceExcelRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const VisitAverageAttendanceExcelSuccess = state => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
}, d)
const VisitAverageAttendanceExcelError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.VisitAverageAttendanceExcelRequest]: VisitAverageAttendanceExcelRequest,
  [Types.VisitAverageAttendanceExcelSuccess]: VisitAverageAttendanceExcelSuccess,
  [Types.VisitAverageAttendanceExcelError]: VisitAverageAttendanceExcelError,
},
{
  defaultActions: {
    get: true,
  },
  Types,
},
)



// WEBPACK FOOTER //
// ./src/Data/Redux/VisitAverageAttendanceRedux.js